import React /*, { Component }*/ from 'react';
import page from 'page'
import timeout from './rAF'

// Containers
import Lot from '../containers/Lot'
import FixedPriceLot from '../containers/FixedPriceLot'
import Pay from '../containers/Pay'
import Checkout from '../containers/Checkout'
import Home from '../containers/Home'
import Lots from '../containers/Lots'
import PreviewLots from '../containers/PreviewLots'
import PreviewLot from '../containers/PreviewLot'
import FixedPriceLots from '../containers/FixedPriceLots'
import Arts from '../containers/Arts'
import News from '../containers/News'
import Found from '../containers/Fund'
import Help from '../containers/Donate/Help'
import CybersportHelp from '../containers/Donate/CybersportHelp'
import Founds from '../containers/Funds'
import NotFound from '../containers/404'
//import Search from '../containers/Search'
//import Signin from '../containers/Signin'
import Member from '../containers/Member'
import Meeting from '../containers/Meeting'
import Visits from '../containers/roles/person/Visits';
import Documents from '../containers/roles/person/Documents';
import Reporting from '../containers/roles/person/Reporting';
import Profile from '../containers/Profile'
import PersonProfile from '../containers/PersonProfile'
import Members from '../containers/Members'
import Article from '../containers/Article'
import Contacts from '../containers/Contacts'
import EngContacts from '../containers/EngContacts'
import Partners from '../containers/Partners'
import Static from '../containers/Static'
import Video from '../containers/Video'
import Donate from '../containers/Donate/Donate'
import Dr from '../containers/Donate/Dr'
import GiftCards from '../containers/GiftCards'
import GiftCardsCheck from '../containers/GiftCardsCheck'
import Charity from '../containers/Donate/Charity'
import Connect from '../containers/Connect'
import HeroRequest from '../containers/HeroRequest'
import Skolkovo from '../containers/Donate/Skolkovo'
import SkolkovoOffer from '../containers/Donate/SkolkovoOffer'
import AboutUs from '../containers/AboutUs'
import GiftCardsRules from '../containers/GiftCardsRules'
import Massmedia from '../containers/Massmedia'
import PayNotification from '../containers/PayNotification';
import Auctions from '../containers/roles/person/Auctions';
import Persons from '../containers/Persons';

// Components
/**import Header from '../components/Header'
import Footer from '../components/Footer'
import Menu from '../components/MobileMenu'
import Overlay from '../components/Overlay'
import ChooseRole from '../components/Profile/ChooseRole'

import EditForm from '../components/Profile/Edit'
import ClaimForm from '../components/Profile/Claim'

import Region from '../components/Region/Region'
import EmailPopup from '../components/EmailPopup'*/


const {SITE} = require('../store/middlewares/api.js');

//объект распределяющий доступ пользователей на сайте
export const PERMISSION = {
    unautorized: {
        profile: NotFound,
        contacts: Contacts,
        lots: Lots,
        lot: Lot,
        arts: Arts,
        //fixedpricelot: FixedPriceLot,
        help: Help,
        // meeting: NotFound,
        meeting: Meeting,
        personVisits: NotFound, //страница всех встреч для персоны, где она сможет выбрать даты '/personvisits' - не показываем
        personDocuments: NotFound, //страница документов персоны - здесь не отображаем '/persondocuments'
        reporting: NotFound, // страница отчетности пока есть только у персоны '/reporting'
        previewlots: NotFound, // страница предпросмотра лотов '/previewlots/:id' не показываем
        previewlot: NotFound,
        payFail: NotFound, // ошибка операции оплаты '/paynotification/:fail?'
        fixedpricelot: FixedPriceLot, // страница фикслота '/fixedpricelots/:id'
        lotsBid: NotFound, //страница ставки по лоту '/lots/:id/bid/:bidId'
        fixlotBid: NotFound, //страница ставки по фикслоту '/fixedpricelots/:id/bid/:bidId'
        funds: Founds, //страница фондов '/funds'
        fund: Found, //страница фонда '/funds/:id'
        members: Members, //страница участников '/members'
        member: Member, //страница участника '/members/:id'
        partners: Partners, //страница партнеров '/partners'
        news: News, //страница новостей '/news'
        massmedia: Massmedia, //страница сми '/massmedia'
        article: Article, //страница новости '/news/:id'
        checkout: Checkout, //страница проверки платежа(наверное) '/checkout/:id'
        payments: NotFound, //страница платежа(наверное) '/payments/:id'
        video: Video, //страница видео '/video'
        mechetin: Donate, //страница доната '/mechetin'
        mechetinDr: Dr, // др мфц '/mechetin/dr'
        skolkovo: Skolkovo, //пожертвование для сколково '/skolkovo'
        skolkovoOffer: SkolkovoOffer, //публичная аферта skolkovo '/skolkovo/offer'
        offrer: SkolkovoOffer, //публичная аферта skolkovo '/help/offer'
        giftcardsbuy: NotFound, // купить подарочную карту '/giftcardsbuy'
        giftcards: GiftCards, //подарочные карты '/giftcards'
        giftcardsRules: GiftCardsRules, //Правила использования подарочных карт '/giftcards/rules'
        giftcardssignin: NotFound, //подарочные карты '/giftcardssignin'
        giftcardBalance: NotFound, //проверка баланса подарочной карты '/giftcard/balance'
        connect: Connect, //анкета для подключения фонда '/connect'
        heroRequest: HeroRequest, //заявка на согласование участия героя '/hero-request'
        charity: Charity, //пожертвование '/charity'
        paymentsTab: NotFound, // чтото по платежам'/payments/:id/:tab'
        alias: Static, //именованные ссылки? '/:alias'
        persons: Persons, //страница "Стать участником"
    },

    user: {
      home: Home, //домашняя страница '/'
      profile: Profile, //страница профиля '/profile'
      contacts: Contacts, // страница контактов с мфц '/contacts'
      lots: Lots, // страница лотов '/lots'
      arts: Arts, // страница лотов деятелей искусства '/arts'
      fixedpricelots: FixedPriceLots, //страница фикс лотов '/fixedpricelots'
      help: Help, //страница хелп '/help'
      lot: Lot, //страница лота '/lots/:id'
      personVisits: NotFound, //страница всех встреч для персоны, где она сможет выбрать даты '/personvisits' - не показываем
      personDocuments: NotFound, //страница документов персоны - здесь не отображаем '/persondocuments'
      reporting: NotFound, // страница отчетности пока есть только у персоны '/reporting'
      meeting: Meeting, //страница встречи с выбором дат '/visits/:id'
      previewlots: PreviewLots, // страница предпросмотра лотов '/previewlots/:id' - в будущем должна быть только для админов
      previewlot: PreviewLot, // страница предпросмотра лота '/previewlot/:id' - в будущем должна быть только для админов
      payFail: PayNotification, // ошибка операции оплаты '/paynotification/:fail?'
      fixedpricelot: FixedPriceLot, // страница фикслота '/fixedpricelots/:id'
      lotsBid: Lot, //страница ставки по лоту '/lots/:id/bid/:bidId'
      fixlotBid: FixedPriceLot, //страница ставки по фикслоту '/fixedpricelots/:id/bid/:bidId'
      funds: Founds, //страница фондов '/funds'
      fund: Found, //страница фонда '/funds/:id'
      members: Members, //страница участников '/members'
      member: Member, //страница участника '/members/:id'
      partners: Partners, //страница партнеров '/partners'
      news: News, //страница новостей '/news'
      massmedia: Massmedia, //страница сми '/massmedia'
      article: Article, //страница новости '/news/:id'
      checkout: Checkout, //страница проверки платежа(наверное) '/checkout/:id'
      payments: Pay, //страница платежа(наверное) '/payments/:id'
      video: Video, //страница видео '/video'
      mechetin: Donate, //страница доната '/mechetin'
      mechetinDr: Dr, // др мфц '/mechetin/dr'
      skolkovo: Skolkovo, //пожертвование для сколково '/skolkovo'
      skolkovoOffer: SkolkovoOffer, //публичная аферта skolkovo '/skolkovo/offer'
      offrer: SkolkovoOffer, //публичная аферта skolkovo '/help/offer'
      giftcardsbuy: NotFound, // купить подарочную карту '/giftcardsbuy'
      giftcards: GiftCards, //подарочные карты '/giftcards'
      giftcardsRules: GiftCardsRules, //Правила использования подарочных карт '/giftcards/rules'
      giftcardssignin: GiftCards, //подарочные карты '/giftcardssignin'
      giftcardBalance: GiftCardsCheck, //проверка баланса подарочной карты '/giftcard/balance'
      connect: Connect, //анкета для подключения фонда '/connect'
      heroRequest: HeroRequest, //заявка на согласование участия героя '/hero-request'
      charity: Charity, //пожертвование '/charity'
      paymentsTab: Pay, // чтото по платежам'/payments/:id/:tab'
      alias: Static, //именованные ссылки? '/:alias'
      persons: Persons, //страница "Стать участником"

    },

    person: {
        home: Home, //домашняя страница '/'
        profile: PersonProfile, //страница профиля '/profile'
        contacts: Contacts, // страница контактов с мфц '/contacts'
        lots: Auctions, // страница аукционов '/lots'
        arts: Arts, // страница лотов деятелей искусства '/arts'
        fixedpricelots: FixedPriceLots, //страница фикс лотов '/fixedpricelots'
        help: Help, //страница хелп '/help'
        lot: Lot, //страница лота '/lots/:id'
        personVisits: Visits, //страница всех встреч для персоны, где она сможет выбрать даты '/personvisits'
        personDocuments: Documents, //страница документов персоны '/persondocuments'
        reporting: Reporting, // страница отчетности пока есть только у персоны '/reporting'
        meeting: Meeting, //страница встречи с выбором дат '/visits/:id' - в будущем должна быть другой для персоны
        previewlots: PreviewLots, // страница предпросмотра лотов '/previewlots/:id' не показываем
        previewlot: PreviewLot, // страница предпросмотра лота '/previewlot/:id' не показываем
        payFail: NotFound, // ошибка операции оплаты '/paynotification/:fail?'
        fixedpricelot: FixedPriceLot, // страница фикслота '/fixedpricelots/:id'
        lotsBid: NotFound, //страница ставки по лоту '/lots/:id/bid/:bidId'
        fixlotBid: NotFound, //страница ставки по фикслоту '/fixedpricelots/:id/bid/:bidId'
        funds: NotFound, //страница фондов '/funds'
        fund: Found, //страница фонда '/funds/:id'
        members: NotFound, //страница участников '/members'
        member: NotFound, //страница участника '/members/:id' - пусть пока будет 404
        partners: Partners, //страница партнеров '/partners'
        news: News, //страница новостей '/news'
        massmedia: Massmedia, //страница сми '/massmedia'
        article: Article, //страница новости '/news/:id'
        checkout: NotFound, //страница проверки платежа(наверное) '/checkout/:id'
        payments: NotFound, //страница платежа(наверное) '/payments/:id'
        video: Video, //страница видео '/video'
        mechetin: Donate, //страница доната '/mechetin'
        mechetinDr: Dr, // др мфц '/mechetin/dr'
        skolkovo: Skolkovo, //пожертвование для сколково '/skolkovo'
        skolkovoOffer: SkolkovoOffer, //публичная аферта skolkovo '/skolkovo/offer'
        offrer: SkolkovoOffer, //публичная аферта skolkovo '/help/offer'
        giftcardsbuy: NotFound, // купить подарочную карту '/giftcardsbuy'
        giftcards: GiftCards, //подарочные карты '/giftcards'
        giftcardsRules: GiftCardsRules, //Правила использования подарочных карт '/giftcards/rules'
        giftcardssignin: NotFound, //подарочные карты '/giftcardssignin'
        giftcardBalance: NotFound, //проверка баланса подарочной карты '/giftcard/balance'
        connect: Connect, //анкета для подключения фонда '/connect'
        heroRequest: HeroRequest, //заявка на согласование участия героя '/hero-request'
        charity: Charity, //пожертвование '/charity'
        paymentsTab: NotFound, // чтото по платежам'/payments/:id/:tab'
        alias: Static, //именованные ссылки? '/:alias'
        persons: NotFound, //страница "Стать участником"

    },

    fund: {
      home: Home, //домашняя страница '/'
      contacts: Contacts, // страница контактов с мфц '/contacts'
      profile: NotFound, // '/contacts' пока не создали страницу для фондов
      lots: Lots, // страница лотов '/lots'
      arts: Arts, // страница лотов деятелей искусства '/arts'
      fixedpricelots: FixedPriceLots, //страница фикс лотов '/fixedpricelots'
      help: Help, //страница хелп '/help'
      lot: Lot, //страница лота '/lots/:id'
      personVisits: NotFound, //страница всех встреч для персоны, где она сможет выбрать даты '/personvisits' - не показываем
      personDocuments: NotFound, //страница документов персоны - здесь не отображаем '/persondocuments'
      reporting: NotFound, // страница отчетности пока есть только у персоны '/reporting'
      meeting: NotFound, //страница встречи с выбором дат '/visits/:id' - для фонда пока не нужна
      previewlots: NotFound, // страница предпросмотра лотов '/previewlots/:id' не показываем
      previewlot: NotFound, // страница предпросмотра лота '/previewlot/:id' не показываем
      payFail: NotFound, // ошибка операции оплаты '/paynotification/:fail?'
      fixedpricelot: FixedPriceLot, // страница фикслота '/fixedpricelots/:id'
      lotsBid: NotFound, //страница ставки по лоту '/lots/:id/bid/:bidId'
      fixlotBid: NotFound, //страница ставки по фикслоту '/fixedpricelots/:id/bid/:bidId'
      funds: NotFound, //страница фондов '/funds'
      fund: NotFound, //страница фонда '/funds/:id'
      members: NotFound, //страница участников '/members' - в будущем возможно выводить участников от фонда
      member: NotFound, //страница участника '/members/:id' - аналогично свойству выше
      partners: Partners, //страница партнеров '/partners'
      news: News, //страница новостей '/news'
      massmedia: Massmedia, //страница сми '/massmedia'
      article: Article, //страница новости '/news/:id'
      checkout: NotFound, //страница проверки платежа(наверное) '/checkout/:id'
      payments: NotFound, //страница платежа(наверное) '/payments/:id'
      video: Video, //страница видео '/video'
      mechetin: Donate, //страница доната '/mechetin'
      mechetinDr: Dr, // др мфц '/mechetin/dr'
      skolkovo: Skolkovo, //пожертвование для сколково или вообще ? '/skolkovo'
      skolkovoOffer: SkolkovoOffer, //публичная аферта skolkovo '/skolkovo/offer'
      offrer: SkolkovoOffer, //публичная аферта skolkovo '/help/offer'
      giftcardsbuy: NotFound, // купить подарочную карту '/giftcardsbuy'
      giftcards: GiftCards, //подарочные карты '/giftcards'
      giftcardsRules: GiftCardsRules, //Правила использования подарочных карт '/giftcards/rules'
      giftcardssignin: NotFound, //подарочные карты '/giftcardssignin'
      giftcardBalance: NotFound, //проверка баланса подарочной карты '/giftcard/balance'
      connect: Connect, //анкета для подключения фонда '/connect'
      heroRequest: HeroRequest, //заявка на согласование участия героя '/hero-request'
      charity: Charity, //пожертвование '/charity'
      paymentsTab: NotFound, // чтото по платежам'/payments/:id/:tab'
      alias: Static, //именованные ссылки? '/:alias'
      persons: NotFound, //страница "Стать участником"

    }
}

export default function getRoutes(self, objRole = PERMISSION) {
    /*
    для того, чтобы роутинг динамически менялся, в вызове функции page, в конструкции self.setState
    состояние надо менять не напрямую, а передавая в self.setState функцию, которая содержит текущие state и props
    и уже обращаясь к objRole[props.role], мы уже правильно ссылаемся на нужный компонент, соответствующий текущей роли
    ВАЖНО: первый аргумент self (на текущий момент это Layout.jsx) должен иметь props.role
    */

    page('/catalog-8f3k', () => {
        window.location.replace('/assets/files/hidden/mfc-catalog-8f3k2x9q.pdf')
    })

    page('*', (ctx, next) => {
        if (ctx.init) next()
        else {
            document.body.classList.add('is-animate')

            timeout(() => {
                window.scrollTo(0, 0)
            }, 300)

            timeout(() => {
                document.body.classList.remove('is-animate')
            next()
            }, 400)
        }
    })

    page('/404', () => {
        self.setState({
            container: <NotFound />,
            isIndex: false,
            isLight: true,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        })
    })

    page('/', (ctx) => {
        self.setState({
            container: <Home
            meta = {
                {
                    name: 'Meet For Charity',
                    description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                    image: SITE+'assets/img/preview/3.png'
                }
            }/>,
            isIndex: true,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        })
    })

    page('/profile', (ctx) => {
        self.setState((state, props) => {
            const ProfilePage = objRole[props.role].profile;
            return {
                container: <ProfilePage on404={self.handle404} user={props.user} />,
                isIndex: false,
                isLight: props.role === 'person' ? false : false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: props.role === 'person' ? true : true
            }
        })
    })

    page('/contacts', (ctx) => {
        self.setState((state, props) => ({
            container: <Contacts />,
            isIndex: false,
            isLight: true,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false

        }))
    })

    page('/eng-contacts', (ctx) => {
        self.setState((state, props) => ({
            container: <EngContacts />,
            isIndex: false,
            isLight: true,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false

        }))
    })

    page('/lots', (ctx) => {
        self.setState((state, props) => {
            const LotsPage = objRole[props.role].lots;
            return {
                container: <LotsPage
                meta = {
                    {
                        name: 'Список лотов Meet For Charity',
                        description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                        image: SITE+'assets/img/preview/1.png'
                    }
                }
                user = {props.role === 'person' ? props.user: null}
                />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: props.role === 'person' ? true : false
            }
        })
    })

    page('/persons', (ctx) => {
        self.setState((state, props) => {
            const PersonsPage = objRole[props.role].persons;
            return {
                container: <PersonsPage
                    role={props.role}
                />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: props.role === 'person' ? true : false
            }
        })
    })

    page('/arts', (ctx) => {
        self.setState((state, props) => ({
            container: <Arts
            meta = {
                {
                    name: 'Список проектов Meet For Charity',
                    description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                    image: SITE+'assets/img/preview/1.png'
                }
            }
            />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/fixedpricelots', (ctx) => {
        self.setState((state, props) => ({
            container: <FixedPriceLots
            meta = {
                {
                    name:'Список фикслотов Meet For Charity',
                    description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                    image: SITE+'assets/img/preview/2.png'
                }
            }
            />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/help', (ctx) => {
        self.setState((state, props) => ({
            container: <Help id='help' on404={self.handle404} />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: true,//оранжевый низ
            isHalfLight: false
        }))
    })

    page('/help/falcon_thanks', () => {
       window.location.replace('https://c.cloudpayments.ru/payments/457fb5d2151b47bfb3fcc9eac023ecc0')

      self.setState({
        container: <div className='Container Home__news-title'>Пожертвование в пользу meetforcharity.today</div>,
        isIndex: false,
        isLight: false,//светлый header
        isBottomWhite: false,//белый низ
        isBottomOrange: false,
        isHalfLight: false
      })
    })

    page('/aboutus', (ctx) => {
        self.setState((state, props) => ({
            container: <AboutUs id='help' on404={self.handle404} />,
            isIndex: false,
            isLight: false,//светлый header
            isBottomWhite: true,//белый низ
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/lots/:id', (ctx) => {
        self.setState((state, props) => ({
            container: <Lot id={ctx.params.id} on404={self.handle404} />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: true
        }))
    })

    page('/visits/:id', (ctx) => {
        self.setState((state, props) => {
            const MeetingPage = objRole[props.role].meeting;
            return {
                container: <MeetingPage id={ctx.params.id} role={props.role} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/personvisits', (ctx) => {
        self.setState((state, props) => {
            const VisitsPage = objRole[props.role].personVisits;
            return {
                container: <VisitsPage user={props.user} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/persondocuments', (ctx) => {
        self.setState((state, props) => {
            const DocumentPage = objRole[props.role].personDocuments;
            return {
                container: <DocumentPage id={ctx.params.id} on404={self.handle404} user={props.user}/>,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/reporting', (ctx) => {
        self.setState((state, props) => {
            const ReportingPage = objRole[props.role].reporting;
            return {
                container: <ReportingPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/previewlots/:id', (ctx) => {
        self.setState((state, props) => {
            const PreviewLotsPage = objRole[props.role].previewlots;
            return {
                container: <PreviewLotsPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: true,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })
    page('/previewlot/:id', (ctx) => {
        self.setState((state, props) =>({statsPage: true}))//возможно надо указать this вместо self
        self.setState((state, props) => {
            const PreviewLotPage = objRole[props.role].previewlot;
            return {
                container: <PreviewLotPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })
    page('/paynotification/:fail?', (ctx) => {
        self.setState((state, props) => ({statsPage: true}))//возможно надо указать this вместо self
        self.setState((state, props) => {
            const PayFailPage = objRole[props.role].payFail;
            return {
                container: <PayFailPage fail={ctx.params.fail} on404={self.handle404} />,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/fixedpricelots/:id', (ctx) => {
        self.setState((state, props) => {
            const FixLotPage = objRole[props.role].fixedpricelot;
            return {
                container: <FixLotPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/lots/:id/bid/:bidId', (ctx) => {
        self.setState((state, props) => {
            const LotsBidPage = objRole[props.role].lotsBid;
            return {
                container: <LotsBidPage id={ctx.params.id} bidId={ctx.params.bidId} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/fixedpricelots/:id/bid/:bidId', (ctx) => {
        self.setState((state, props) => {
            const FixLotBidPage = objRole[props.role].fixlotBid;
            return {
                container: <FixLotBidPage id={ctx.params.id} bidId={ctx.params.bidId} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/funds', (ctx) => {
        self.setState((state, props) => {
            const FundsPage = objRole[props.role].funds;
            return {
                container: <FundsPage
                meta = {
                    {
                        name: 'Фонды в Meet For Charity',
                        description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                        image: SITE+'assets/img/preview/4.png'
                    }
                }/>,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/funds/:id', (ctx) => {
        self.setState((state, props) => {
            const FundPage = objRole[props.role].fund;
            return {
                container: <FundPage id={
                ctx.params.id}
                on404={self.handle404}
                meta = {
                    {
                        name: 'Фонд в Meet For Charity',
                        description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                        image: SITE+'assets/img/preview/5.png'
                    }
                }/>,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/members', (ctx) => {
        self.setState((state, props) => {
            const MembersPage = objRole[props.role].members;
            return {
                container: <MembersPage
                meta = {
                    {
                        name: 'Участники Meet For Charity',
                        description: 'Выиграйте встречу мечты и поддержите тех, кто в этом нуждается!',
                        image: SITE+'assets/img/preview/6.png'
                    }
                }/>,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/members/:id', (ctx) => {
        self.setState((state, props) => {
            const MemberPage = objRole[props.role].member;
            return {
                container: <MemberPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    // page('/partners', (ctx) => { TEMP HIDE
    //     self.setState((state, props) => ({
    //         container: <Partners />,
    //         isIndex: false,
    //         isLight: true,
    //         isBottomWhite: false,
    //         isBottomOrange: false,
    //         isHalfLight: false
    //     }))
    // })

    page('/news', (ctx) => {
        self.setState((state, props) => ({
            container: <News />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/massmedia', (ctx) => {
        self.setState((state, props) => ({
            container: <Massmedia
                meta = {
                    {
                        name: 'СМИ о нас',
                        description: 'Упоминания MeetForCharity в СМИ',
                        //image: SITE+'assets/img/preview/1.png'
                    }
                }
            />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/news/:id', (ctx) => {
        self.setState((state, props) => ({
            container: <Article articleId={ctx.params.id} on404={self.handle404} />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })


    page('/checkout/:id', (ctx) => {
        self.setState((state, props) => {
            const CheckPayPage = objRole[props.role].checkout;
            return {
                container: <CheckPayPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/payments/:id', (ctx) => {
        self.setState((state, props) => {
            const PayPage = objRole[props.role].payments;
            return {
                container: <PayPage id={ctx.params.id} on404={self.handle404} />,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/video', (ctx) => {
        self.setState((state, props) => ({
            container: <Video />,
            isIndex: false,
            isLight: true,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/mechetin', (ctx) => {
        self.setState((state, props) => ({
            container: <Donate />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/mechetin/dr', (ctx) => {
        self.setState((state, props) => ({
            container: <Dr />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/skolkovo', (ctx) => {
        self.setState((state, props) => ({
            container: <Skolkovo />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/skolkovo/offer', (ctx) => {
        self.setState((state, props) => ({
            container: <SkolkovoOffer />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: true
        }))
    })

    page('/help/offer', (ctx) => {
        self.setState((state, props) => ({
            container: <SkolkovoOffer />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: true
        }))
    })


    // page('/giftcardsbuy', (ctx) => {
    //     self.setState((state, props) => {
    //         const GiftCardPayPage = objRole[props.role].giftcardsbuy;
    //         return {
    //             container: <GiftCardPayPage />,
    //             isIndex: false,
    //             isLight: true,
    //             isBottomWhite: false,
    //             isBottomOrange: false,
    //             isHalfLight: false
    //         }
    //     })
    // })

    page('/giftcards', (ctx) => {
        self.setState((state, props) => {
            const GiftCardPage = objRole[props.role].giftcards;
            return {
                container: <GiftCardPage />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/giftcards/rules', (ctx) => {
        self.setState((state, props) => {
            const GiftCardRulesPage = objRole[props.role].giftcardsRules;
            return {
                container: <GiftCardRulesPage />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('/giftcardssignin', (ctx) => {//тем, кто оплатил подарочную карту предложить зарегистрироваться
        self.setState((state, props) => {
            // если пользователь уже зарегистрирован, у него есть роль
            // ему не нужно показывать страницу входа
            if (props.role == 'user') return page.redirect('/giftcard/balance')

            const GiftCardSigninPage = objRole[props.role].giftcardssignin;
            return {
                container: <GiftCardSigninPage />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,//true,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
        self.setState({ registrationLogin: true })
    })

    page('/giftcard/balance', (ctx) => {
        self.setState((state, props) => {
            const GiftCardSigninPage = objRole[props.role].giftcardBalance;
            return {
                container: <GiftCardSigninPage />,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
            }
        })
    })


    page('/connect', (ctx) => {
        self.setState((state, props) => {
            const ConnectPage = objRole[props.role].connect;
            return {
                container: <ConnectPage />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/hero-request', (ctx) => {
        self.setState((state, props) => {
            const HeroRequestPage = objRole[props.role].heroRequest;
            return {
                container: <HeroRequestPage />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/charity', (ctx) => {
        self.setState((state, props) => ({
            container: <Charity />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })

    page('/donate', (ctx) => {
        self.setState((state, props) => ({
            container: <CybersportHelp id='help' on404={self.handle404} />,
            isIndex: false,
            isLight: false,
            isBottomWhite: false,
            isBottomOrange: false,//оранжевый низ
            isHalfLight: false
        }))
    })

    page('/payments/:id/:tab', (ctx) => {
        self.setState((state, props) => {
            const PaymentsTabPage = objRole[props.role].paymentsTab;
            return {
                container: <PaymentsTabPage id={ctx.params.id} tab={ctx.params.tab} on404={self.handle404} />,
                isIndex: false,
                isLight: true,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: false
            }
        })
    })

    page('/:alias', (ctx) => {
        self.setState((state, props) => {
            const AliasPage = objRole[props.role].alias
            return {
                container: <AliasPage alias={ctx.params.alias} on404={self.handle404} />,
                isIndex: false,
                isLight: false,
                isBottomWhite: false,
                isBottomOrange: false,
                isHalfLight: true
            }
        })
    })

    page('*', () => {
        self.setState((state, props) => ({
            container: <NotFound />,
            isIndex: false,
            isLight: true,
            isBottomWhite: false,
            isBottomOrange: false,
            isHalfLight: false
        }))
    })


    page()
}



// WEBPACK FOOTER //
// ./src/helpers/getRoutes.jsx